import angular from 'angular';
import { Organization } from '../../organizations';
import activitiesTemplate from './activities.html';

class ActivitiesController {
  static $inject = ['Activity', 'ActivityModal', 'AuthService'];

  activities: any[] = [];
  organizations: Organization[] = [];

  constructor(
    private Activity,
    private ActivityModal,
    private AuthService,
  ) { }

  $onInit() {
    this.Activity.query().then((activities) => {
      this.activities = activities;
      const organizations: Organization[] = [];
      const map = new Map();
      for (const organization of activities.map(
        (activity) => activity.organization,
      )) {
        if (!map.has(organization.id)) {
          map.set(organization.id, true);
          organizations.push({
            id: organization.id,
            name: organization.name,
          });
        }
      }
      this.organizations = organizations;
    });
  }

  byOrganization(organization) {
    return function (activity) {
      return activity.organization.id === organization.id;
    };
  }

  addActivity() {
    this.AuthService.me().then((me) => {
      this.ActivityModal.add(me.organizations).then(
        (activity) => {
          this.activities.push(activity);
          this.Activity.save(activity);
        },
        () => {
          //Modal dismissed
        },
      );
    });
  }

  remove(activity) {
    this.Activity.remove({ id: activity.id }, () => {
      const idx = this.activities.indexOf(activity);
      this.activities.splice(idx, 1);
    });
  }

  edit(activity) {
    const updatedActivity = angular.copy(activity);
    this.AuthService.me().then((me) => {
      this.ActivityModal.edit(me.organizations, updatedActivity).then(
        (result) => {
          const idx = this.activities.indexOf(activity);
          this.activities.splice(idx, 1, result);
          this.Activity.update(result);
        },
        () => {
          //Modal dismissed
        },
      );
    });
  }

  isPersonal(activity) {
    return activity.type == 'PERSONAL';
  }
}

export const ActivitiesComponent = {
  template: activitiesTemplate,
  controller: ActivitiesController,
};